import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer,  
  TableRow 
} from '@mui/material';


const ProfitShareFees = ({data}) => {

  const {
    elecReimbursementConsol,
    transactionFeeConsol,
    omCosts

  } = data;

  return (
    <div className="mb-6">
      <TableContainer  
          aria-label="ProfitShareFees" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
        <Table>
          <TableBody>
            <TableRow>
                <TableCell sx={{fontWeight: 'bold'}}>Cost of electricity consumed</TableCell>
                <TableCell align='right'>{`£${elecReimbursementConsol.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{fontWeight: 'bold'}}>Transaction Fees</TableCell>
                <TableCell align='right'>{`£${transactionFeeConsol.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{fontWeight: 'bold'}}>O&M Costs</TableCell>
                <TableCell align='right'>{`£${omCosts.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}


export default ProfitShareFees;

ProfitShareFees.propTypes = {
  data: PropTypes.object.isRequired,
};
